(function () {
  "use strict";

  DeleteGroupCtrl.$inject = ['$scope', '$timeout'];
  angular
    .module('trainerWebApp.modals')
    .controller('DeleteGroupCtrl', DeleteGroupCtrl);

  function DeleteGroupCtrl($scope, $timeout) {

    $scope.modal = {
      content: 0,
      data: {},
      userCount: 0,
      trainerCount: 0,
      showTrainerMsg: false,
      status: '',
      confirmed: false
    };

    $scope.deleteGroup = function () {
      $scope.modal.status = 'saving';
      $scope.modal.confirmed = true;
      $scope.$emit('deleteGroupConfirmEvent', $scope.modal.data, function () {
        $scope.dismiss();
        $timeout(function () {
          $scope.modal.status = ''
        }, 500);
      });
    };

    $scope.$on('deleteGroupEvent', function (event, group) {
      $scope.modal.status = '';
      $scope.modal.data = group.id;
      $scope.modal.content = group.name;
      $scope.modal.userCount = group.userCount;
      $scope.modal.trainerCount = group.numOfUniqueTrainer;
      $scope.modal.showTrainerMsg = group.numOfUniqueTrainer > 0;
      $scope.modal.confirmed = false;
      $scope.show();
    });

  }

})();
